import { render, staticRenderFns } from "./ContatoForm.vue?vue&type=template&id=59535a1e&"
import script from "./ContatoForm.vue?vue&type=script&lang=js&"
export * from "./ContatoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports